import { render, staticRenderFns } from "./WarrantyBillItem.vue?vue&type=template&id=22c0901e&scoped=true"
import script from "./WarrantyBillItem.vue?vue&type=script&lang=js"
export * from "./WarrantyBillItem.vue?vue&type=script&lang=js"
import style0 from "./WarrantyBillItem.vue?vue&type=style&index=0&id=22c0901e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0901e",
  null
  
)

export default component.exports